<template>
  <section class="game-section">
    <b-container class="position-relative">
      <div class="avatar-container">
        <img class="grexy-avatar-image avatar-1" src="../assets/img/game-avatar-1.png" alt="Game avatar image">
        <img class="grexy-avatar-image avatar-2" src="../assets/img/game-avatar-2.png" alt="Game avatar image">
        <img class="grexy-avatar-image avatar-3" src="../assets/img/game-avatar-3.png" alt="Game avatar image">
      </div>
      <b-row>
        <b-col sm="12">
          <h4 class="title-how-works text-center">{{$t('title_game_section')}}</h4>
        </b-col>
        <b-col sm="12" md="6">
          <div style="display: flex;height: 100%; align-items: center;">
            <div class="game-info-container">
              <img class="icon-game-bg" src="../assets/img/game-bg-icon.svg" alt="Grexy game image">
              <h4 class="game-title-content">{{$t('game_title_content')}}</h4>
              <p class="game-text-content">{{$t('game_text_content')}}</p>
            </div>
          </div>
        </b-col>
        <b-col sm="12" md="6" class="text-center">
          <img v-if="$i18n.locale === 'en'" class="grexy-game-image" src="../assets/img/game-banner-image-en.png" alt="Grexy game image">
          <img v-else-if="$i18n.locale === 'uk'" class="grexy-game-image" src="../assets/img/game-banner-image-new.png" alt="Grexy game image">
          <img  v-else class="grexy-game-image" src="../assets/img/game-banner-image-new.png" alt="Grexy game image">
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>
<script>
export default {

  data () {
    return {
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/sass/app.scss";
.game-section{
  background: radial-gradient(66.25% 121.93% at 70.64% -15.07%, #8184F9 12.26%, #5C5EE8 91.15%);
  padding: 70px 0 0 0;
  overflow: hidden;
  @media screen and (min-width: 320px) {
    padding-top: 30px;
  }
  @media screen and (min-width: 768px) {
  }
  @media screen and (min-width: 992px) {
  }
  @media screen and (min-width: 1440px) {
    padding: 70px 0 0 0;
  }
  @media screen and (min-width: 1920px) {
  }
  .title-how-works{
    color: #FFF;
    font-family: $main-font;

    font-style: normal;
    font-weight: 700;
    line-height: 120%; /* 57.6px */
    @media screen and (min-width: 320px) {
      margin-bottom: 40px;
      font-size: 40px;
    }
    @media screen and (min-width: 768px) {
      font-size: 32px;
    }
    @media screen and (min-width: 992px) {
      position: relative;
      top: 40px;
      margin-bottom: 0;
    }
    @media screen and (min-width: 1440px) {
      font-size: 48px;

    }
    @media screen and (min-width: 1920px) {

    }
  }
  .game-info-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    position: relative;
    border-radius: 20px;
    background: #ffffff;
    backdrop-filter: blur(8px);
    padding: 32px;

    .game-title-content{
      color: #232333;
      font-family: $main-font;
      font-size: 32px;
      font-style: normal;
      font-weight: 700;
      line-height: 38.4px;
      margin: 0 0 24px 0;
      z-index: 2;
      @media screen and (min-width: 320px) {
        font-size: 24px;
        line-height: 28.8px;
      }
      @media screen and (min-width: 768px) {
      }
      @media screen and (min-width: 992px) {
      }
      @media screen and (min-width: 1440px) {
        font-size: 32px;
      }
      @media screen and (min-width: 1920px) {
      }
    }
    .game-text-content{
      color: #232333;
      font-family: $main-font;
      font-size: 18px;
      font-style: normal;
      font-weight: 300;
      line-height: 25.2px;
      margin: 0;
      z-index: 2;
      @media screen and (min-width: 320px) {
        font-size: 18px;
        margin: 0 0 24px 0;
      }
      @media screen and (min-width: 768px) {
        font-size: 16px;
        margin: 0;
      }
      @media screen and (min-width: 992px) {
      }
      @media screen and (min-width: 1440px) {
        font-size: 18px;
      }
      @media screen and (min-width: 1920px) {
      }
    }
    .icon-game-bg{
      position: absolute;
      top: 80px;
      left: -152px;
      z-index: 1;
      width: 100%;
      max-width: 187px;
      height: auto;
      @media screen and (min-width: 320px) {
        max-width: 105px;
        top: -35px;
        left: -26px;
      }
      @media screen and (min-width: 768px) {
        top: 0;
        left: -52px;
      }
      @media screen and (min-width: 992px) {
        top: 100px;
        left: -50px;
      }
      @media screen and (min-width: 1440px) {
        top: 40px;
        left: -208px;
        max-width: 187px;
      }
      @media screen and (min-width: 1920px) {
        top: -150px;
        left: -208px;
      }
    }
  }
  .grexy-game-image{
    width: 100%;
    height: auto;
    @media screen and (min-width: 320px) {
      max-width: 327px;
      margin-top: 24px;
    }
    @media screen and (min-width: 768px) {
      max-width: 340px;
    }
    @media screen and (min-width: 992px) {
      max-width: 520px;
      margin-top: 0;
    }
    @media screen and (min-width: 1440px) {
      max-width: 600px;
    }
    @media screen and (min-width: 1920px) {
    }
  }
  .avatar-container{
    @media screen and (min-width: 320px) {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    @media screen and (min-width: 768px) {
    }
    @media screen and (min-width: 992px) {
    }
    @media screen and (min-width: 1440px) {
    }
    @media screen and (min-width: 1920px) {
    }
  }
  .grexy-avatar-image{
    width: 100px;
    height: 100px;
    position: absolute;
    z-index: 1;
    @media screen and (min-width: 320px) {
      position: unset;
      width: 90px;
      height: 90px;
      margin-bottom: 20px;
    }
    @media screen and (min-width: 768px) {
    }
    @media screen and (min-width: 992px) {
      position: absolute;
    }
    @media screen and (min-width: 1440px) {
    }
    @media screen and (min-width: 1920px) {
    }
  }
  .avatar-1{
    top: 0;
    left: 40px;
  }
  .avatar-2{
    bottom: 20px;
    left: 40%;
  }
  .avatar-3{
    right: -10%;
    top: calc(50% - 50px)
  }
  .grexy-avatar-image {
    transition: transform 0.3s ease;
  }
}
.grexy-avatar-image {
  transition: transform 0.3s ease;
}

.game-section:hover .avatar-1 {
  transform: translateX(10px);
}

.game-section:hover .avatar-2 {
  transform: translateX(-10px);
}

.game-section:hover .avatar-3 {
  transform: translateY(-10px);
}
</style>
